import { motion } from "framer-motion";
import { BadgeCheck, Leaf, ShieldCheck, UserCheck } from "lucide-react";

const badges = [
  { icon: BadgeCheck, title: "100% Satisfaction", text: "Not happy? We come back and re-clean, free." },
  { icon: Leaf, title: "Eco-Friendly Products", text: "Family and pet safe, kind to the planet." },
  { icon: ShieldCheck, title: "Fully Insured", text: "Complete cover on every visit, every time." },
  { icon: UserCheck, title: "Vetted Professionals", text: "Background-checked, trained & uniformed." },
];

export const TrustBadges = () => (
  <section data-testid="trust-badges-section" className="bg-white py-20 lg:py-24">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 lg:px-12">
      {badges.map((b, i) => (
        <motion.div
          key={b.title}
          data-testid={`trust-badge-${i}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col gap-4"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-50 text-teal-700">
            <b.icon className="h-6 w-6" />
          </span>
          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.12em] text-slate-900">{b.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-500">{b.text}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
